import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
  ProfitMargin,
  Reminder,
  ResetAccount,
} from '@C/Settings/RouteComponents';

const RouteSetup = () => {
  const env = process.env.ENVIRONMENT;
  return (
    <Switch>
      {env === 'development' && (
        <Route
          path="/account/app-settings/reminder-notifications"
          component={Reminder}
        />
      )}
      <Route
        path="/account/app-settings/reset-account"
        component={ResetAccount}
      />
      <Route
        path="/account/app-settings/profit-margin"
        component={ProfitMargin}
      />
      <Route path="/account/app-settings/*">
        <Redirect to={`/account/app-settings/profit-margin`} />
      </Route>
    </Switch>
  );
};

export { RouteSetup };
